import {
  addStreetAltNameGuard,
  createStreetGuard,
  replaceStreetGuard,
} from './_api/streets';

export const createStreet = createStreetGuard;
export const addStreetAltName = addStreetAltNameGuard;
export const replaceStreet = replaceStreetGuard;

// The tool is worth opening if any single action is permitted.
export const manageStreets = {
  oneOf: [createStreetGuard, addStreetAltNameGuard, replaceStreetGuard],
};
